<script setup lang="ts">
definePageMeta({
  middleware: ['02-pharmacy-routing'],
  nonPharmacyRoute: 'markenuebersicht-slug',
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
